import "@arcgis/map-components/components/arcgis-daylight";
import "./daytime.css";
import Description from "../Description";

function DayTime() {
  return (
    <>
      <arcgis-daylight referenceElement="viewDiv"></arcgis-daylight>
    </>
  );
}

export default DayTime;
